module.exports = {
  "version": "0.26.1"
};


//////////////////
// WEBPACK FOOTER
// C:/PhpstormProjects/e-crewing/~/axios/lib/env/data.js
// module id = 17
// module chunks = 0 1 2 3